import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import update from 'react-addons-update';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function moveItem(_ref) {
  var dragItem = _ref.dragItem,
      pathFrom = _ref.pathFrom,
      pathTo = _ref.pathTo;
  var extraProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var childrenProp = this.props.childrenProp;
  var items = this.state.items; // the remove action might affect the next position,
  // so update next coordinates accordingly

  var realPathTo = this.getRealNextPath(pathFrom, pathTo);
  var removePath = this.getSplicePath(pathFrom, {
    numToRemove: 1,
    childrenProp: childrenProp
  });
  var insertPath = this.getSplicePath(realPathTo, {
    numToRemove: 0,
    itemsToInsert: [dragItem],
    childrenProp: childrenProp
  });
  items = update(items, removePath);
  items = update(items, insertPath);
  this.setState(_objectSpread({
    items: items,
    isDirty: true
  }, extraProps));
}

export { moveItem };
//# sourceMappingURL=moveItem.js.map
